export const supportedLanguages = [
  { code: 'en' },
  { code: 'fr' },
  { code: 'it' },
  { code: 'ru' }
];
